import { Map as ImmutableMap } from 'immutable';
import { PAGE_VIEW } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { getBaseEventBasedFilterFamilyField, getEventBasedFilterFamilyFields, getRefinementCondition } from '../strategy/eventBasedFilters';
import { useGetOperators } from './useGetOperators';
export const usePageViewFilter = (condition, onChange) => {
  const {
    getRefinementOperators
  } = useGetOperators();
  const statusCondition = condition.set('field', getBaseEventBasedFilterFamilyField(PAGE_VIEW));
  const dateRefinementCondition = getRefinementCondition(PAGE_VIEW, condition.dateRefinement);
  const numberRefinementCondition = dateRefinementCondition ? undefined : getRefinementCondition(PAGE_VIEW, condition.numberRefinement);
  const onStatusChange = pageViewStatusCondition => {
    const value = pageViewStatusCondition && pageViewStatusCondition.value;
    const enableTracking = pageViewStatusCondition && pageViewStatusCondition.enableTracking;
    const utmBase = pageViewStatusCondition && pageViewStatusCondition.utmBase;
    const utmParameters = pageViewStatusCondition && pageViewStatusCondition.utmParameters;
    let newCondition = condition.set('value', value);
    if (typeof enableTracking !== 'undefined') {
      newCondition = newCondition.set('enableTracking', enableTracking);
    }
    if (typeof utmBase !== 'undefined') {
      newCondition = newCondition.set('utmBase', utmBase);
    }
    if (typeof utmParameters !== 'undefined') {
      newCondition = newCondition.set('utmParameters', utmParameters);
    }
    onChange(newCondition);
  };
  const getRefinementsWithEmptyValue = refinementFields => {
    return refinementFields.map(field => {
      const operators = getRefinementOperators(PAGE_VIEW, field);
      return operators.first().of(field);
    });
  };
  const refinementFields = getEventBasedFilterFamilyFields(PAGE_VIEW, ImmutableMap(), condition, true);
  const refinementConditionsEmptyValue = getRefinementsWithEmptyValue(refinementFields.toArray());
  return {
    statusCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onStatusChange
  };
};